import api from './api';

// Tüm kullanıcıları getir
export const getAllUsers = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const response = await api.get(`/admin/users?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Get all users error:', error);
    throw error.response?.data || error;
  }
};

// Bekleyen kullanıcıları getir
export const getPendingUsers = async () => {
  try {
    const response = await api.get('/admin/users/pending');
    return response.data;
  } catch (error) {
    console.error('Get pending users error:', error);
    throw error.response?.data || error;
  }
};

// Admin istatistikleri
export const getAdminStats = async () => {
  try {
    const response = await api.get('/admin/stats');
    return response.data;
  } catch (error) {
    console.error('Get admin stats error:', error);
    throw error.response?.data || error;
  }
};

// Kullanıcıyı onayla
export const approveUser = async (userId) => {
  try {
    const response = await api.put(`/admin/users/${userId}/approve`);
    return response.data;
  } catch (error) {
    console.error('Approve user error:', error);
    throw error.response?.data || error;
  }
};

// Kullanıcıyı reddet
export const rejectUser = async (userId, reason = '') => {
  try {
    const response = await api.put(`/admin/users/${userId}/reject`, { reason });
    return response.data;
  } catch (error) {
    console.error('Reject user error:', error);
    throw error.response?.data || error;
  }
};

// Kullanıcı detayı
export const getUserDetail = async (userId) => {
  try {
    const response = await api.get(`/admin/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Get user detail error:', error);
    throw error.response?.data || error;
  }
};

// Onaylı kullanıcıları getir
export const getApprovedUsers = async () => {
  try {
    const response = await api.get('/admin/users/approved/list');
    return response.data;
  } catch (error) {
    console.error('Get approved users error:', error);
    throw error.response?.data || error;
  }
};

// Kullanıcıyı sil
export const deleteUser = async (userId) => {
  try {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Delete user error:', error);
    throw error.response?.data || error;
  }
};
